module.exports = __webpack_public_path__ + "static/media/5.be55b4e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructorsPhoto/5.jpg
// module id = 246
// module chunks = 1